import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { startRequest as userLogout } from '../Authorization/redux/logout/actions';
import { startRequest as getAppIsReadyCheck } from './redux/actions';
import { appIsReadySelect, errorSelect, isLoadingSelect } from './redux/selectors';
import Loading from 'components/Loading';

const AppIsReadyCheckWrapper = (props) => {
  const { children } = props;
  const dispatch = useDispatch();
  const isLoading = useSelector(isLoadingSelect);
  const appIsReady = useSelector(appIsReadySelect);
  const error = useSelector(errorSelect);
  const [isPending, setIsPending] = useState(true);

  useEffect(() => {
    dispatch(getAppIsReadyCheck());
  }, []);

  useEffect(() => {
    if (error) {
      dispatch(userLogout());

      return;
    }
    if (isLoading) {
      return;
    }

    if (!isLoading && appIsReady === true) {
      setIsPending(false);

      return;
    }

    if (!isLoading && appIsReady === false) {
      setTimeout(() => {
        dispatch(getAppIsReadyCheck());
      }, 5000);
    }
  }, [isLoading, appIsReady, error]);

  return (
    <>
      {isPending ? (
        <div className="main-page_bg">
          <Loading />
        </div>
      ) : (
        children
      )}
    </>
  );
};

AppIsReadyCheckWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default AppIsReadyCheckWrapper;
